import { useContext, useEffect } from "react";
import Questions from "./Questions";
import { QuizContext } from "../contexts/quiz";

const Quiz = () => {
  const [quizState, dispatch] = useContext(QuizContext);
  const apiUrl =
    "https://opentdb.com/api.php?amount=10&category=18&difficulty=easy&type=multiple";
  useEffect(() => {
    if (quizState.questions.length > 0) {
      return;
    }
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => dispatch({ type: "FETCHED", payload: data.results }))
      .catch((error) =>
        dispatch({ type: "SERVER_ERROR", payload: error.message })
      );
  });
  //});
  console.log("quizState", quizState);
  return (
    <div className="quiz">
      {quizState.errorMsg && (
        <div className="results">
          <div className="congratulations">SERVER ERROR</div>
          <div className="results-info">
            <div>{quizState.errorMsg}</div>
          </div>
        </div>
      )}
      {quizState.showResults && (
        <div className="results">
          <div className="congratulations">Congratulations</div>
          <div className="results-info">
            <div>You have completed the quiz</div>
            <div>
              You have got {quizState.countcorrectAnswer} out of{" "}
              {quizState.questions.length}
            </div>
          </div>
          <div
            className="next-button"
            onClick={() => dispatch({ type: "RESTART" })}
          >
            {" "}
            Restart{" "}
          </div>
        </div>
      )}
      {!quizState.showResults && quizState.questions.length > 0 && (
        <div>
          <div className="score">
            Question {quizState.currentQuestionIndex + 1}/
            {quizState.questions.length}
          </div>
          <Questions />
          <div
            className="next-button"
            onClick={() => dispatch({ type: "NEXT_QUESTION" })}
          >
            Next Question
          </div>
        </div>
      )}
    </div>
  );
};

export default Quiz;
